export class ExtendValid {

  public static luhnAlgorithm (value: string): boolean {
    value = value.replaceAll(' ', '').replaceAll('.', '').replaceAll(':', '');
    let res: boolean;
    let somme = 0;
    let tmp = 0;
    for (let cpt = 0; cpt < value.length; cpt++) {
      tmp = parseInt(value.charAt(value.length - cpt - 1))
      if ((cpt % 2) == 1) { // Les positions paires
        tmp = tmp * 2; // On le multiplie par 2
        if (tmp > 9) {
          tmp -= 9;	// Si le résultat est supérieur à 9, on lui soustrait 9
        }
      }
      somme += tmp;
    }
    if ((somme % 10) == 0) {
      res = true;	// Si la somme est un multiple de 10 alors le SIREN est valide
    } else {
      res = false;
    }
    return res;
  }

  public static numSecuValide (value: string): boolean {
    // traitement cas de la Corse on rend la zone a tester numérique
    const s7 = value.substring(6, 7)
    if ((s7 == "A") || (s7 == "B")) {
      const s6 = value.substring(5, 6)
      if (s6 != "2") {
        return false;
      }
      value = value.substring(0, 6) + "0" + value.substring(7, 15);
    }
    // La zone doit alors etre numérique et ne contenir que 15 digits on valide par expression régulière
    const filter = /^\d{15}$/;
    if (!filter.test(value)) {
      return false
    }
    // la zone est numérique avec 15 caractères
    if ((value.substring(0, 1) != "1") && (value.substring(0, 1) != "2")) {
      return false;
    }

    let deb13 = parseInt(value.substring(0, 13));
    // traiter le cas de la corse
    if (s7 == "A") deb13 -= 1000000;
    if (s7 == "B") deb13 -= 2000000;
    // La Clé SS est égale au reste de la division par 97
    const div97 = 97 - (deb13 % 97);
    const sdiv97 = (div97 > 9 ? '' : '0') + String(div97);

    if (value.substring(13, 15) != sdiv97) {
      return false;
    }
    return true;
  }

  public static numSecuProvisoireValide (value: string): boolean {
    // traitement cas de la Corse on rend la zone a tester numérique
    const s7 = value.substring(6, 7)
    if ((s7 == "A") || (s7 == "B")) {
      const s6 = value.substring(5, 6)
      if (s6 != "2") {
        return false;
      }
      value = value.substring(0, 6) + "0" + value.substring(7, 15);
    }
    // La zone doit alors etre numérique et ne contenir que 7 digits on valide par expression régulière
    const filter = /^\d{7}$/;
    if (!filter.test(value)) {
      return false
    }

    if ((value.substring(0, 1) != "1") && (value.substring(0, 1) != "2")) {
      return false;
    }

    let deb13 = parseInt(value.substring(0, 13));
    // traiter le cas de la corse
    if (s7 == "A") deb13 -= 1000000;
    if (s7 == "B") deb13 -= 2000000;

    const month =  parseInt(value.substring(3, 5));

    if ((month < 1 || month > 12) && (month != 99)) {
      return false;
    }

    return true;
  }

  public static objetPoleEmploiValide (value: string): boolean {

    const normalized = (value ?? '').replace(/\s/g, '').toUpperCase();
    const filter = /^(?:\d{3}Z|\d{2}[A-Z]{2})\d{8}$/;
    if (!filter.test(normalized)) {
      return false
    }
    const concat = normalized.substring(0, 2) + normalized.substring(4, 10)
    const deb13 = parseInt(concat);

    // La Clé est égale au reste de la division par 97
    const div97 = 97 - (deb13 % 97);
    const sdiv97 = (div97 > 9 ? '' : '0') + String(div97);

    if (normalized.substring(10, 12) != sdiv97) {
      return false;
    }
    return true;
  }

  public static numeroCarteValid (value: string): boolean {
    const visa = /^4\d{3}(| |-)(?:\d{4}\1){2}\d{4}$/;
    const mastercard = /^5[1-5]\d{2}(| |-)(?:\d{4}\1){2}\d{4}$/;
    const amEx = /^3[47]\d{1,2}(| |-)\d{6}\1\d{6}$/;

    if (visa.test(value)) {
      return true;
    } else if (mastercard.test(value)) {
      return true;
    } else if (amEx.test(value)) {
      return true;
    } else {
      return false;
    }

  }

  public static validCarteValid (value: string): boolean {

    const regX = /^(0[1-9]|1[0-2])\/([0-9]{4}|[0-9]{2})$/;

    if (regX.test(value)) {
      const today = new Date();
      const arrDate = value.split('/');
      const expiryDate = new Date(parseInt('20' + arrDate[1]), parseInt(arrDate[0]) - 1, 30);
      if (expiryDate > today) {
        return true;
      } else {
        return false;
      }
    } else { return true; }

  }

  public static isValidIBANNumber (input: string): boolean {
    // eslint-disable-next-line
    const CODE_LENGTHS: any = {
      AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
      CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
      FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
      HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
      LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
      MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
      RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
    };
    const iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
      code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/); // match and capture (1) the country code, (2) the check digits, and (3) the rest

    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
      return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    // eslint-disable-next-line
    const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter: any): string => {
      return (letter.charCodeAt(0) - 55).toString();
    });
    // final check
    return this.mod97(digits);
  }

  // eslint-disable-next-line
  public static mod97 (value: any): boolean {
    let checksum = value.slice(0, 2), fragment;
    for (let offset = 2; offset < value.length; offset += 7) {
      fragment = String(checksum) + value.substring(offset, offset + 7);
      checksum = parseInt(fragment, 10) % 97;
    }
    return checksum == 1;
  }

  public static isValidUrssafEmployeur (value: string): boolean {
    // To override in control
      return true;
  }

  public static isValidCongeSpecEmployeur (value: string): boolean {

    if (value.length == 9 || value.length == 11) {
      const dCle = value.charCodeAt(value.length - 1);
      const dNum = Number(value.substring(0, value.length - 1));

      let iValCle = 0;
      if (dCle >= 65 && dCle <= 72) { // between A & H
        iValCle = dCle - 64;
      } else if (dCle >= 74 && dCle <= 78) { // between J & N
        iValCle = dCle - 64 - 1;
      } else if (dCle >= 80 && dCle <= 89) { // between P & Y
        iValCle = dCle - 64 - 2;
      }

      if (iValCle > 0) {
        const iReste = dNum % 23;
        if (iReste + 1 == iValCle) {
          return true;
        }
      }
    }

    return false;
  }

  public static isValidCongeSpecSalarie (value: string): boolean {
    value = value.replaceAll(' ', '');
    if (value.length == 7) {
      value = value.slice(0, 1) + '0' + value.slice(1);
    }
    if (value.length == 8) {
      const dCle = value.charCodeAt(0);
      const dNum = Number(value.substring(1));

      let iValCle = 0;
      if (dCle >= 65 && dCle <= 72) { // between A & H
        iValCle = dCle - 64;
      } else if (dCle >= 74 && dCle <= 78) { // between J & N
        iValCle = dCle - 64 - 1;
      } else if (dCle >= 80 && dCle <= 89) { // between P & Y
        iValCle = dCle - 64 - 2;
      }

      if (iValCle > 0) {
        const iReste = dNum % 23;
        if (iReste + 1 == iValCle) {
          return true;
        }
      }
    }
    return false;
  }

  public static isValidMailLive (value: string): boolean {

    const regX = /[&"()!$*€£`+=;?#%<>§^¨°[\]{}]/;

    if (regX.test(value)) {
        return false;     
    } else {
      return true;
    }
  }

  public static cardExpirationValid (input: string): boolean {
    const today = new Date();
    const expirydate = new Date();
    const month =  parseInt(input.slice(0, -2));
    if (month <=12 && month > 0) {
      const year = parseInt(input.slice(-2));
      expirydate.setFullYear(2000+year, month, 0);
      return today < expirydate;
    } else {
      return false;
    }
  }
  
}
